/**
 * La provincia a partir del código postal (auditoría del onboarding del
 * 2026-10-29, hallazgo 14).
 *
 * En España las dos primeras cifras del código postal SON la provincia, en el
 * orden alfabético de 1833 que todavía usan Correos y el INE (01 Álava ...
 * 52 Melilla). No hace falta ninguna lista de municipios ni ningún servicio:
 * el municipio sigue escrito a mano, porque un mismo código postal puede
 * repartirse entre varios.
 *
 * Es una SUGERENCIA para el campo, que sigue siendo editable. Nunca pisa lo
 * que la persona haya escrito: sólo rellena una provincia vacía, o la que se
 * rellenó sola con el código postal anterior.
 *
 * PURO: sin red y sin React.
 */

const PROVINCIAS: readonly string[] = [
  "Álava", "Albacete", "Alicante", "Almería", "Ávila", "Badajoz", "Illes Balears", "Barcelona", "Burgos", "Cáceres",
  "Cádiz", "Castellón", "Ciudad Real", "Córdoba", "A Coruña", "Cuenca", "Girona", "Granada", "Guadalajara", "Gipuzkoa",
  "Huelva", "Huesca", "Jaén", "León", "Lleida", "La Rioja", "Lugo", "Madrid", "Málaga", "Murcia",
  "Navarra", "Ourense", "Asturias", "Palencia", "Las Palmas", "Pontevedra", "Salamanca", "Santa Cruz de Tenerife", "Cantabria", "Segovia",
  "Sevilla", "Soria", "Tarragona", "Teruel", "Toledo", "Valencia", "Valladolid", "Bizkaia", "Zamora", "Zaragoza",
  "Ceuta", "Melilla",
];

/** La provincia de un código postal español de cinco cifras, o `null`. */
export function provinciaDelCp(cp: string): string | null {
  const limpio = cp.trim();
  if (!/^\d{5}$/.test(limpio)) return null;
  // El prefijo se compara como TEXTO: la web no convierte nada a número.
  const i = PROVINCIAS.findIndex((_, k) => String(k + 1).padStart(2, "0") === limpio.slice(0, 2));
  return i === -1 ? null : (PROVINCIAS[i] ?? null);
}

/**
 * Los datos con el código postal nuevo y, si toca, la provincia sugerida.
 * Toca cuando la provincia está vacía o es la que dio el código anterior.
 */
export function conCodigoPostal<D extends { readonly postalCode: string; readonly province: string }>(d: D, cp: string): D {
  const sugerida = provinciaDelCp(cp);
  const anterior = provinciaDelCp(d.postalCode);
  const rellenable = d.province.trim() === "" || (anterior !== null && d.province === anterior);
  return { ...d, postalCode: cp, province: sugerida !== null && rellenable ? sugerida : d.province };
}
